import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState, mapGetters } from "vuex";
import { CHANGE_CONSENT_STATUS, LOAD_APPLICATIONS_WITH_INFO_FOR_CLIENT } from "../store/applications-list-actions";
import { APPLICATIONS_BY_CLIENT } from "../store/applications-list-getters";
import ClientApplication from "./client-application";
import _ from "lodash";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ViewClientApplications",
  components: {
    ClientApplication
  },
  props: {
    agentUsername: {
      type: String,
      default: ""
    },
    clientUsername: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: true
    },
    copyingApp: {
      type: Boolean,
      default: false
    },
    fullyLoaded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingApplications: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationsListStore", ["applications", "clients"])), mapGetters("ApplicationsListStore", [APPLICATIONS_BY_CLIENT])), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    isViewOnly() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    applicationsByClient() {
      var _context;
      const applications = this.APPLICATIONS_BY_CLIENT(this.clientUsername);
      return _mapInstanceProperty(_context = _.orderBy(applications, ["createdAt"], ["desc"])).call(_context, (app, index) => _objectSpread(_objectSpread({}, app), {}, {
        isLast: index === applications.length - 1
      }));
    }
  }),
  mounted() {
    if (!this.fullyLoaded) {
      this.LOAD_APPLICATIONS_WITH_INFO_FOR_CLIENT({
        clientUsername: this.clientUsername,
        agentUsername: this.agentUsername
      }).then(() => {
        this.loadingApplications = false;
      });
    } else {
      this.loadingApplications = false;
    }
    this.$nextTick(() => {
      $(".consent-status-tooltip").tooltip();
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [CHANGE_CONSENT_STATUS, LOAD_APPLICATIONS_WITH_INFO_FOR_CLIENT])), {}, {
    createAdditionalApp(event) {
      event.preventDefault();
      this.$emit("additional-app");
    },
    openModal(street, applicationId, currentMainApplicantAddress, documentCount) {
      this.$emit("open-modal", {
        street,
        applicationId,
        currentMainApplicantAddress,
        documentCount
      });
    }
  })
});